import { ICompareFavoriteVehicles } from '@allesauto/core/favoritesCompareCard';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/store/redux';

export interface FavoritesCompareState {
  vehicles: ICompareFavoriteVehicles[];
}

const initialState: FavoritesCompareState = {
  vehicles: [],
};

const SLICE_NAME = 'favorites';

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    handleSelectedFavoritesVehicle(
      state,
      action: PayloadAction<{
        comparedVehicle: ICompareFavoriteVehicles;
        displayToast?: () => void;
      }>
    ) {
      const { comparedVehicle, displayToast } = action.payload;
      const selectedIndex = state.vehicles.findIndex(
        (vehicle) => vehicle.id === comparedVehicle.id
      );

      if (selectedIndex === -1) {
        if (state.vehicles.length < 3) state.vehicles.push(comparedVehicle);
        else displayToast && displayToast();
      } else {
        state.vehicles = [
          ...state.vehicles.slice(0, selectedIndex),
          ...state.vehicles.slice(selectedIndex + 1),
        ];
      }
    },
    handleUpdateFavoriteState(
      state,
      action: PayloadAction<FavoritesCompareState>
    ) {
      return action.payload;
    },

    reset() {
      return initialState;
    },
  },
});

export const {
  handleSelectedFavoritesVehicle,
  handleUpdateFavoriteState,
  reset,
} = slice.actions;

export const getFavoritesState = (state: RootState): FavoritesCompareState =>
  state.pages.favorites;

export default slice.reducer;
